const tooltips = {
    keszletszintfield: 'Alapértelmezett készletszint, mely minden raktárra vonatkozik, amíg külön raktárankénti készletszint megadásra nem kerül.',
    ertesites: 'A Készletszint figyelés fülön megadott készletszintek adott raktárban történő elérése esetén a listában szereplő e-mail címekre megy ki értesítés.',
    keszletszintcikk: 'A Cikk(ek) tényleges kiválasztásához a Nagyító ikon megnyomása szükséges.'
  };
  
  export default function getTooltip(name) {
    return tooltips[name];
  }
  